<template>
    <el-dialog
        title="邮件明细"
        :visible.sync="dialogVisible"
        width="80%"
        :before-close="handleClose"
        :close-on-click-modal="false"
    >
        <div v-loading="loading">
            <el-table
                ref="emailTable"
                :data="emailList"
                border
                @selection-change="handleSelectionChange"
                max-height="500"
            >
                <el-table-column
                    type="selection"
                    width="55"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="firstDeptName"
                    show-overflow-tooltip
                    label="总部职能部门"
                    min-width="200"
                    align="left">
                </el-table-column>
                <el-table-column
                    prop="receiver"
                    show-overflow-tooltip
                    label="收件人"
                    min-width="150"
                    align="left">
                </el-table-column>
                <el-table-column
                    prop="fileName"
                    label="邮件标题"
                    show-overflow-tooltip
                    min-width="250"
                    align="left">
                </el-table-column>
                <el-table-column
                    prop="fileNameFull"
                    label="附件"
                    show-overflow-tooltip
                    min-width="250"
                    align="left">
                    <template slot-scope="scope">
                        <span 
                            v-if="scope.row.fileNameFull && scope.row.fileUrl"
                            @click="downloadAttachment(scope.row)"
                            style="color: #409EFF; cursor: pointer; text-decoration: underline;"
                        >
                            {{ scope.row.fileNameFull }}
                        </span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="handleConfirmSend" :disabled="selectedRows.length === 0">确认发送</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { defineComponent, ref, watch, getCurrentInstance } from 'vue'
import { awaitWrapper, downloadFileFromUrl } from "@/common/utils/assist.js"
import { getEmailList, sendEmail } from './request.js'

export default defineComponent({
    name: 'EmailDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        params: {
            type: Object,
            default: () => ({})
        },
        title: {
            type: String,
            default: '预算执行情况分析'
        }
    },
    setup(props, { emit }) {
        const { proxy } = getCurrentInstance()
        const dialogVisible = ref(false)
        const loading = ref(false)
        const emailList = ref([])
        const selectedRows = ref([])

        // 监听 visible 变化
        watch(() => props.visible, (newVal) => {
            dialogVisible.value = newVal
            if (newVal) {
                fetchEmailList()
            }
        }, { immediate: true })

        // 获取邮件列表
        const fetchEmailList = async () => {
            loading.value = true
            const [, res] = await awaitWrapper(getEmailList(props.params))
            loading.value = false
            if (res && res.code == 0 && res.data) {
                emailList.value = (res.data || []).map(item => {
                    let receiver = Array.isArray(item.emails) ? item.emails.map(emailInfo=>emailInfo.chineseName+'(' + emailInfo.staffNo + ')').join(';') : '--';

                    return {
                        ...item,
                        receiver,
                        // mailTitle: props.title
                    }
                })
            } else {
                emailList.value = []
            }
        }

        // 选择变化
        const handleSelectionChange = (selection) => {
            selectedRows.value = selection
        }

        // 下载附件
        const downloadAttachment = async (row) => {
            if (!row.fileUrl) {
                proxy.$message.warning('附件地址不存在')
                return
            }
            try {
                loading.value = true
                await downloadFileFromUrl(row.fileUrl, row.fileNameFull)
                loading.value = false
                proxy.$message.success('下载成功')
            } catch (error) {
                loading.value = false
                proxy.$message.error('下载失败')
            }
        }

        // 确认发送
        const handleConfirmSend = async () => {
            if (selectedRows.value.length === 0) {
                proxy.$message.warning('请选择要发送的邮件')
                return
            }

            try {
                await proxy.$confirm('确认发送选中的邮件吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })

                loading.value = true
                const [, res] = await awaitWrapper(sendEmail(selectedRows.value))
                loading.value = false

                if (res && res.code == 0) {
                    proxy.$message.success('发送成功')
                    handleClose()
                    emit('success')
                }
            } catch (error) {
                // 用户取消操作
            }
        }

        // 关闭弹窗
        const handleClose = () => {
            dialogVisible.value = false
            selectedRows.value = [];
            emailList.value = [];
            emit('update:visible', false)
        }

        return {
            dialogVisible,
            loading,
            emailList,
            selectedRows,
            handleSelectionChange,
            downloadAttachment,
            handleConfirmSend,
            handleClose
        }
    }
})
</script>

<style lang="scss" scoped>
</style>
